import { useEffect, useState } from "react";
import { bool, object, func, arrayOf } from "prop-types";
import {
  getProfessionalLevelsQuery,
  getStackTypeQuery,
  getTeamMembersQuery,
  getTeamRoleQuery,
  refreshUserDataQuery
} from "@query";
import { TEAM_ROLES } from "@utils";
import { useStores } from "@hooks";
import { TeamTable } from "./components/TeamTable";

export const TeamView = ({
  useTableTitle,
  users: providedUsers,
  handleLoad,
}) => {
  const { userStore } = useStores();

  const [ isLoading, setIsLoading ] = useState(true);
  const [ users, setUsers ] = useState(providedUsers || []);
  const [ professionalLevels, setLevels ] = useState([]);
  const [ teamRoles, setRoles ] = useState([]);
  const [ stackTypes, setStackTypes ] = useState([]);

  const { isAdmin } = userStore;

  const loadData = async (email = null) => {
    if (!isLoading) setIsLoading(true);
    if (email && email === userStore.data.email) {
      const userData = await refreshUserDataQuery();
      userStore.saveUserData(userData);
    }
    
    if(handleLoad) {
      handleLoad();
    } else {
      const res = await getTeamMembersQuery();
      setUsers(res);
    }
    setIsLoading(false);
  };

  const loadInputData = async () => {
    const r = await Promise.all([
      getProfessionalLevelsQuery(),
      getStackTypeQuery(),
      getTeamRoleQuery(),
    ]);

    setLevels(r[0]);
    setStackTypes(r[1]);
    setRoles(!isAdmin ? r[2].filter((r) => r.id !== TEAM_ROLES.ADMIN) : r[2]);
  };

  useEffect(() => {
    loadData();
    loadInputData();
  }, []);
  
  useEffect(() => {
    if(providedUsers && handleLoad)
      setUsers(providedUsers);
  }, [ providedUsers ]);

  return (
    <TeamTable
      isLoading={isLoading}
      reloadData={loadData}
      users={users}
      professionalLevels={professionalLevels}
      teamRoles={teamRoles}
      stackTypes={stackTypes}
      useTableTitle={useTableTitle}
    />
  );
};

TeamView.propTypes = {
  useTableTitle: bool,
  users: arrayOf(object),
  handleLoad: func
}